import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusProgramCredentialingQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusProgramCredentialingQuery = { readonly __typename?: 'Query', readonly epocusProgramCredentialing: { readonly __typename?: 'EpocusProgramCredentialing', readonly programId: string, readonly programQaAveragePct?: number | null, readonly qaAverageWindowDays: number, readonly counts: { readonly __typename?: 'EpocusCredentialingCounts', readonly provisional: number, readonly inProgress: number, readonly credentialed: number }, readonly rows: ReadonlyArray<{ readonly __typename?: 'EpocusCredentialingRow', readonly performerId: string, readonly name?: string | null, readonly unit?: string | null, readonly status: Types.EpocusPerformerCredentialStatus, readonly supervisorId?: string | null, readonly supervisorName?: string | null, readonly supervisedStudies: number, readonly qaAveragePct?: number | null }> } };

export type SetEpocusPerformerCredentialMutationVariables = Types.Exact<{
  input: Types.SetEpocusPerformerCredentialInput;
}>;


export type SetEpocusPerformerCredentialMutation = { readonly __typename?: 'Mutation', readonly setEpocusPerformerCredential: { readonly __typename?: 'EpocusPerformerCredential', readonly id: string, readonly programId: string, readonly performerId: string, readonly status: Types.EpocusPerformerCredentialStatus, readonly supervisorId?: string | null, readonly unit?: string | null, readonly updatedAt: string } };


export const EpocusProgramCredentialingDocument = gql`
    query EpocusProgramCredentialing($programId: ID!) {
  epocusProgramCredentialing(programId: $programId) {
    programId
    counts {
      provisional
      inProgress
      credentialed
    }
    programQaAveragePct
    qaAverageWindowDays
    rows {
      performerId
      name
      unit
      status
      supervisorId
      supervisorName
      supervisedStudies
      qaAveragePct
    }
  }
}
    `;

/**
 * __useEpocusProgramCredentialingQuery__
 *
 * To run a query within a React component, call `useEpocusProgramCredentialingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramCredentialingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramCredentialingQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusProgramCredentialingQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramCredentialingQuery, EpocusProgramCredentialingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramCredentialingQuery, EpocusProgramCredentialingQueryVariables>(EpocusProgramCredentialingDocument, options);
      }
export function useEpocusProgramCredentialingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramCredentialingQuery, EpocusProgramCredentialingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramCredentialingQuery, EpocusProgramCredentialingQueryVariables>(EpocusProgramCredentialingDocument, options);
        }
export type EpocusProgramCredentialingQueryHookResult = ReturnType<typeof useEpocusProgramCredentialingQuery>;
export type EpocusProgramCredentialingLazyQueryHookResult = ReturnType<typeof useEpocusProgramCredentialingLazyQuery>;
export type EpocusProgramCredentialingQueryResult = Apollo.QueryResult<EpocusProgramCredentialingQuery, EpocusProgramCredentialingQueryVariables>;
export const SetEpocusPerformerCredentialDocument = gql`
    mutation SetEpocusPerformerCredential($input: SetEpocusPerformerCredentialInput!) {
  setEpocusPerformerCredential(input: $input) {
    id
    programId
    performerId
    status
    supervisorId
    unit
    updatedAt
  }
}
    `;
export type SetEpocusPerformerCredentialMutationFn = Apollo.MutationFunction<SetEpocusPerformerCredentialMutation, SetEpocusPerformerCredentialMutationVariables>;

/**
 * __useSetEpocusPerformerCredentialMutation__
 *
 * To run a mutation, you first call `useSetEpocusPerformerCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEpocusPerformerCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEpocusPerformerCredentialMutation, { data, loading, error }] = useSetEpocusPerformerCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEpocusPerformerCredentialMutation(baseOptions?: Apollo.MutationHookOptions<SetEpocusPerformerCredentialMutation, SetEpocusPerformerCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEpocusPerformerCredentialMutation, SetEpocusPerformerCredentialMutationVariables>(SetEpocusPerformerCredentialDocument, options);
      }
export type SetEpocusPerformerCredentialMutationHookResult = ReturnType<typeof useSetEpocusPerformerCredentialMutation>;
export type SetEpocusPerformerCredentialMutationResult = Apollo.MutationResult<SetEpocusPerformerCredentialMutation>;
export type SetEpocusPerformerCredentialMutationOptions = Apollo.BaseMutationOptions<SetEpocusPerformerCredentialMutation, SetEpocusPerformerCredentialMutationVariables>;